<template>
  <VCard>
    <VCardText>
      <VResponsive :aspect-ratio="16/9">
        <CameraCheck @checked="cameraChecked" />
      </VResponsive>
    </VCardText>
    <VCardActions>
      <VBtn :disabled="!camera" color="success" @click="done">
        {{ $t('next') }} &rarr;
      </VBtn>
    </VCardActions>
  </VCard>
</template>

<script>
import CameraCheck from '@huntica/huntica-interview-module/src/components/CameraCheck.vue';

export default {
  name: 'OfficeInterviewCameraCheck',
  components: {
    CameraCheck,
  },
  data() {
    return {
      camera: false,
    };
  },
  methods: {
    cameraChecked(value) {
      this.camera = value;
    },
    done() {
      this.$emit('done');
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  next: Next
</i18n>

<i18n locale="ru" lang="yaml">
  next: Далее
</i18n>
